<template>
  <div
    class="floor-box"
    :class="{ current: current }"
    :style="index == 0 ? 'margin-top: 3px;' : ''"
    @click="changeCurrent()"
  >
    <div class="handel-box">
      <div
        class="up-icon"
        v-show="index != 0"
        @click.stop="upFloor(index)"
      ></div>
      <div
        class="down-icon"
        v-show="index != floorCount - 1"
        @click.stop="downFloor(index)"
      ></div>
      <div class="del-icon" @click.stop="delFloor(index)"></div>
    </div>
    <div class="floor-content">
      <el-carousel
        height="110px"
        :indicator-position="item.contentList.length == 1 ? 'none' : ''"
        :interval="10000"
        arrow="never"
      >
        <el-carousel-item
          v-for="(item2, index2) in item.contentList"
          :key="index2"
        >
          <img
            :src="
              item2.swiperImg ||
              require('../../../assets/images/m-decoration/m-default-swiper.png')
            "
            alt=""
            class="swiper-img"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import mFloorHandle from "../../../mixin/m-floor-handle";
export default {
  name: "ShopCenterAdminWebMFloorSwiper",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    current: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
    },
    floorCount: {
      type: Number,
    },
  },
  mixins: [mFloorHandle],
  data() {
    return {};
  },

  mounted() {},

  methods: {
    // 选中楼层
    changeCurrent() {
      // this.$nextTick(() => {
      this.$emit("selectFloor", {
        id: 207,
        index: this.index,
        key: this.item.key,
      });
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.floor-box {
  position: relative;
  height: 110px;
  padding: 15px;
  margin-top: 5px;
  border: 1px solid transparent;
  cursor: pointer;
  &:hover {
    background: #fff;
    border: 1px dashed #197dff;
    border-radius: 6px;
    border-top-right-radius: 0;
    box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
    .handel-box {
      display: flex;
    }
  }
  .handel-box {
    display: none;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    top: -1px;
    right: -30px;
    width: 28px;
    padding-top: 15px;
    border-radius: 0px 5px 5px 0px;
    border-top: 1px dashed #197dff;
    border-right: 1px dashed #197dff;
    border-bottom: 1px dashed #197dff;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(191, 191, 191, 0.25);
    .up-icon {
      width: 13px;
      height: 10px;
      margin-bottom: 15px;
      background: url(../../../assets/images/pc-decoration/up-floor-icon.png)
        no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        background: url(../../../assets/images/pc-decoration/up-floor-icon2.png)
          no-repeat;
        background-size: 100% 100%;
      }
    }
    .down-icon {
      width: 13px;
      height: 10px;
      margin-bottom: 15px;
      background: url(../../../assets/images/pc-decoration/down-floor-icon.png)
        no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        background: url(../../../assets/images/pc-decoration/down-floor-icon2.png)
          no-repeat;
        background-size: 100% 100%;
      }
    }
    .del-icon {
      width: 10px;
      height: 12px;
      margin-bottom: 15px;
      background: url(../../../assets/images/pc-decoration/del-floor-icon.png)
        no-repeat;
      background-size: 100% 100%;
      cursor: pointer;

      &:hover {
        background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .floor-content {
    width: 345px;
    height: 100%;
    .swiper-img {
      width: 345px;
      height: 110px;
      border-radius: 8px;
    }
    ::v-deep .el-carousel__indicator.el-carousel__indicator--horizontal {
      .el-carousel__button {
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #000;
        opacity: 0.2;
      }
      &.is-active {
        .el-carousel__button {
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background: #007aff;
          opacity: 1;
        }
      }
    }
  }
}
.current {
  background: #fff;
  border: 1px dashed #197dff;
  border-radius: 6px;
  border-top-right-radius: 0;
  box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
  .handel-box {
    display: flex;
  }
}
</style>
